import React, { useEffect } from "react";
import { useLocation } from "polyrouter";
import { hasBackgroundImage } from "utilities/misc";
import { THEME_LIGHT } from "store/userMeta";
import { useTranslation } from "utilities/i18n";
import lensLogo from "assets/images/poly_logo_lens.svg";
import { PolyLogoFooter, LoadingIndicator } from "elements";
import { SECOND_IN_MILLISECONDS } from "Constants";

const Feedback: React.FC = () => {
  const { pathname } = useLocation();
  // At this moment desktop app doesn't support dark theme, so use only Light here
  // TODO: Add condition for themes here when desktop app starts supporting dark theme
  const theme = THEME_LIGHT;
  const backgroundStyle = hasBackgroundImage(pathname, theme.toLowerCase());
  const { t } = useTranslation();

  // Mopinion does not replace the contents of #desktopSurveyContent, so this is
  // required to remove the loading indicator once the survey is rendered.
  useEffect(() => {
    const cleanUp = () => {
      document
        .querySelector("#desktopSurveyContent .loading-indicator")
        ?.remove();
      clearInterval(interval);
    };

    const interval = setInterval(() => {
      if (!!document.querySelector(".mopinion-survey-content")) {
        cleanUp();
      }
    }, 0.25 * SECOND_IN_MILLISECONDS);

    setTimeout(cleanUp, 10 * SECOND_IN_MILLISECONDS);

    return () => {
      cleanUp();
    };
  }, []);

  return (
    <div
      className={`main ${
        theme === THEME_LIGHT ? "theme-light" : ""
      } d-flex flex-column align-center relative`}
      style={backgroundStyle}
    >
      <div className="brand mt-2 mb-2">
        <img src={lensLogo} alt="Poly Lens" data-testid="logo" />
      </div>
      <div
        className="card"
        style={{
          maxWidth: "90vw",
          width: "800px",
          maxHeight: "calc(100vh - 164px)",
          minHeight: "40vh"
        }}
      >
        <h6 className="ml-1 mt-1 mb-15">{t("DESKTOP_FEEDBACK_FORM_TITLE")}</h6>
        {/* Mopinion form is configured to wait for this element/id to be rendered
         * Form will be loaded in this div #desktopSurveyContent
         */}
        <div id="desktopSurveyContent">
          <LoadingIndicator />
        </div>
      </div>
      <PolyLogoFooter />
    </div>
  );
};

export default Feedback;
